module.exports = __webpack_public_path__ + "static/media/no-tours-icon.c1737fbf.svg";